import { lazy } from 'react';

export const Dashboard = lazy(() => import('../pages/Dashboard'));
export const ClientDashboard = lazy(() => import('../pages/ClientDashboard'));
export const ClientDefects = lazy(() => import('../pages/ClientDefects'));
export const TesterDashboard = lazy(() => import('../pages/TesterDashboard'));
export const Projects = lazy(() => import('../pages/Projects'));
export const ProjectDetail = lazy(() => import('../pages/ProjectDetail'));
export const ClientProjectDetail = lazy(() => import('../pages/ClientProjectDetail'));
export const ClientTestCycles = lazy(() => import('../pages/ClientTestCycles'));
export const ClientForms = lazy(() => import('../pages/ClientForms'));
export const ClientIntegrations = lazy(() => import('../pages/ClientIntegrations'));
export const ClientTeam = lazy(() => import('../pages/ClientTeam'));
export const TesterTestCycles = lazy(() => import('../pages/TesterTestCycles'));
export const TestCycles = lazy(() => import('../pages/TestCycles'));
export const TestCycleEntry = lazy(() => import('../pages/cycle/TestCycleEntry'));
export const LegacyCycleRoute = lazy(() => import('../pages/cycle/LegacyCycleRoute'));
export const TestExecutionRedirect = lazy(() => import('../pages/cycle/TestExecutionRedirect'));
export const CycleWorkspaceLayout = lazy(() => import('../pages/cycle/CycleWorkspaceLayout'));
export const CycleSetupPanel = lazy(() => import('../pages/cycle/CycleSetupPanel'));
export const CycleTeamPanel = lazy(() => import('../pages/cycle/CycleTeamPanel'));
export const CycleWorkPanel = lazy(() => import('../pages/cycle/CycleWorkPanel'));
export const CycleDefectsPanel = lazy(() => import('../pages/cycle/CycleDefectsPanel'));
export const CycleResultsPanel = lazy(() => import('../pages/cycle/CycleResultsPanel'));
export const CycleRewardsPanel = lazy(() => import('../pages/cycle/CycleRewardsPanel'));
export const CycleTestCasesPanel = lazy(() => import('../pages/cycle/CycleTestCasesPanel'));
export const CycleTestCaseExecutePage = lazy(() => import('../pages/cycle/CycleTestCaseExecutePage'));
export const CycleFormsPanel = lazy(() => import('../pages/cycle/CycleFormsPanel'));
export const CycleMessagesPanel = lazy(() => import('../pages/cycle/CycleMessagesPanel'));
export const CycleAnnouncementsPanel = lazy(() => import('../pages/cycle/CycleAnnouncementsPanel'));
export const CycleBudgetPanel = lazy(() => import('../pages/cycle/CycleBudgetPanel'));
export const CyclePaymentsPanel = lazy(() => import('../pages/cycle/CyclePaymentsPanel'));
export const CycleActivityPanel = lazy(() => import('../pages/cycle/CycleActivityPanel'));
export const FinanceReports = lazy(() => import('../pages/FinanceReports'));
export const FinancePayoutApprovals = lazy(() => import('../pages/FinancePayoutApprovals'));
export const CycleCreateWizard = lazy(() => import('../pages/cycle/CycleCreateWizard'));
export const CreateIssue = lazy(() => import('../pages/CreateIssue'));
export const TesterProfile = lazy(() => import('../pages/TesterProfile'));
export const Devices = lazy(() => import('../pages/Devices'));
export const DeviceCoverage = lazy(() => import('../pages/DeviceCoverage'));
export const TesterCoverage = lazy(() => import('../pages/TesterCoverage'));
export const Tester360 = lazy(() => import('../pages/Tester360'));
export const TesterProjects = lazy(() => import('../pages/TesterProjects'));
export const Academy = lazy(() => import('../pages/Academy'));
export const TesterUserGuide = lazy(() => import('../pages/TesterUserGuide'));
export const RegisteredTesters = lazy(() => import('../pages/RegisteredTesters'));
export const ImportTestersDevices = lazy(() => import('../pages/ImportTestersDevices'));
export const Earnings = lazy(() => import('../pages/Earnings'));
export const Billing = lazy(() => import('../pages/Billing'));
export const Clients = lazy(() => import('../pages/Clients'));
export const Client360 = lazy(() => import('../pages/Client360'));
export const BugTriage = lazy(() => import('../pages/BugTriage'));
export const BugDetail = lazy(() => import('../pages/BugDetail'));
export const MyReportedIssues = lazy(() => import('../pages/MyReportedIssues'));
export const ClientTestCases = lazy(() => import('../pages/ClientTestCases'));
export const Reports = lazy(() => import('../pages/Reports'));
export const Settings = lazy(() => import('../pages/Settings'));
export const KYCReview = lazy(() => import('../pages/KYCReview'));
export const Login = lazy(() => import('../pages/Login'));
export const Signup = lazy(() => import('../pages/Signup'));
export const TesterLogin = lazy(() => import('../pages/TesterLogin'));
export const CycleInviteAccept = lazy(() => import('../pages/CycleInviteAccept'));
export const TesterSignUp = lazy(() => import('../pages/TesterSignUp'));
export const ClientLogin = lazy(() => import('../pages/ClientLogin'));
export const ClientSignUp = lazy(() => import('../pages/ClientSignUp'));
export const EmailVerification = lazy(() => import('../pages/EmailVerification'));
export const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
export const ResetPassword = lazy(() => import('../pages/ResetPassword'));
export const LeadManagement = lazy(() => import('../pages/LeadManagement'));
export const PlatformAdminHub = lazy(() => import('../pages/admin/PlatformAdminHub'));
export const AiCommandCenter = lazy(() => import('../pages/admin/AiCommandCenter'));
export const PlatformAuditLogs = lazy(() => import('../pages/admin/PlatformAuditLogs'));
export const PlatformBtsIntegrations = lazy(() => import('../pages/admin/PlatformBtsIntegrations'));
export const PlatformAppTestifySync = lazy(() => import('../pages/admin/PlatformAppTestifySync'));
export const PlatformRevenueDashboard = lazy(() => import('../pages/admin/PlatformRevenueDashboard'));
export const JobInviteEmails = lazy(() => import('../pages/admin/JobInviteEmails'));
export const CampaignAnalytics = lazy(() => import('../pages/admin/CampaignAnalytics'));
export const CycleOnboardingPanel = lazy(() => import('../pages/cycle/CycleOnboardingPanel'));
export const AccountDeletionRequests = lazy(() => import('../pages/AccountDeletionRequests'));
export const Messages = lazy(() => import('../pages/Messages'));
export const PublicProjectForm = lazy(() => import('../pages/PublicProjectForm'));
export const TesterAssignedForms = lazy(() => import('../pages/TesterAssignedForms'));
export const TesterPayoutCompliance = lazy(() => import('../pages/TesterPayoutCompliance'));
export const ProjectFormResponsesPage = lazy(() => import('../pages/ProjectFormResponsesPage'));
export const ProjectFormSubmissionReportPage = lazy(() => import('../pages/ProjectFormSubmissionReportPage'));
export const TesterOpenCycles = lazy(() => import('../pages/TesterOpenCycles'));
export const StaffProjectDetail = lazy(() => import('../pages/staff/StaffProjectDetail'));
export const StaffProjectCycles = lazy(() => import('../pages/staff/StaffProjectCycles'));
export const StaffProjectForms = lazy(() => import('../pages/staff/StaffProjectForms'));
export const StaffProjectTabView = lazy(() => import('../pages/staff/StaffProjectTabView'));
export const ClientTermsOfService = lazy(() => import('../pages/legal/ClientTermsOfService'));
export const ClientPrivacyPolicy = lazy(() => import('../pages/legal/ClientPrivacyPolicy'));
export const TesterTermsOfService = lazy(() => import('../pages/legal/TesterTermsOfService'));
export const TesterPrivacyPolicy = lazy(() => import('../pages/legal/TesterPrivacyPolicy'));
